/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { googleCalendarAvailabilityControllerFindAllByEmail } from '../fn/google-calendar-availability/google-calendar-availability-controller-find-all-by-email';
import { GoogleCalendarAvailabilityControllerFindAllByEmail$Params } from '../fn/google-calendar-availability/google-calendar-availability-controller-find-all-by-email';
import { ResponseAvailabilityDto } from '../models/response-availability-dto';

@Injectable({ providedIn: 'root' })
export class GoogleCalendarAvailabilityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `googleCalendarAvailabilityControllerFindAllByEmail()` */
  static readonly GoogleCalendarAvailabilityControllerFindAllByEmailPath = '/thalea-google-events/google-calendar-availability/{tenant}/{email}';

  /**
   * Gets the user availability.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleCalendarAvailabilityControllerFindAllByEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleCalendarAvailabilityControllerFindAllByEmail$Response(params: GoogleCalendarAvailabilityControllerFindAllByEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseAvailabilityDto>> {
    return googleCalendarAvailabilityControllerFindAllByEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the user availability.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `googleCalendarAvailabilityControllerFindAllByEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleCalendarAvailabilityControllerFindAllByEmail(params: GoogleCalendarAvailabilityControllerFindAllByEmail$Params, context?: HttpContext): Observable<ResponseAvailabilityDto> {
    return this.googleCalendarAvailabilityControllerFindAllByEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseAvailabilityDto>): ResponseAvailabilityDto => r.body)
    );
  }

}
